import React, { useState } from 'react'
import { Tab, Row, Nav } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { useRouteMatch, Switch, Route } from 'react-router'
import {
  getUserModuleActions,
  getUserSubModuleActions,
} from '../../../../store/user/selectors'
import { checkPermission } from '../../../../utils/utilFunctions'
import GsdFileView from '../../../compensationRecommendation/compensation/gsd/GsdFileView'
import GspApplication from './GspApplication'
import GspFileRegistration from './GspFileRegistration'
import GspReturn from './GspReturn'

const Gsp = () => {
  const { path } = useRouteMatch()
  const [selectedSection, setSelectedSection] = useState('gsd')

  const actionListModule = useSelector(
    getUserModuleActions('application-registration', 'compensation', 'gsd')
  )

  const actionListSubModule = useSelector(
    getUserSubModuleActions(
      'application-registration',
      'compensation',
      'gsd',
      'file-return'
    )
  )
  return (
    <Switch>
      <Route path={`${path}/`} exact>
        <Tab.Container id="left-tabs-example" defaultActiveKey="gsp">
          <Row className="tab-page-layout">
            <Nav variant="pills" className="flex-row">
              {checkPermission('view', actionListModule) && (
                <Nav.Item className="custom-nav-item">
                  <Nav.Link
                    onClick={() => {
                      setSelectedSection('gsd')
                    }}
                    eventKey="gsd"
                  >
                    GSD Application
                  </Nav.Link>
                </Nav.Item>
              )}
              {checkPermission('view', actionListSubModule) && (
                <Nav.Item className="custom-nav-item">
                  <Nav.Link
                    onClick={() => {
                      setSelectedSection('gsd-return')
                    }}
                    eventKey="gsd-return"
                  >
                    GSD Return
                  </Nav.Link>
                </Nav.Item>
              )}
            </Nav>
          </Row>
          <Row className="page-tiles-layout align-content-start">
            {selectedSection === 'gsd' ? (
              <>
                {checkPermission('view', actionListModule) && (
                  <GspApplication />
                )}
              </>
            ) : (
              <>
                {checkPermission('view', actionListSubModule) && <GspReturn />}
              </>
            )}
          </Row>
        </Tab.Container>
      </Route>
      <Route
        path={`${path}/view/:id`}
        render={(props) => <GspFileRegistration type="file" {...props} />}
      />
      <Route
        path={`${path}/return/:id`}
        render={(props) => <GspFileRegistration type="return" {...props} />}
      />
      <Route
        path={`${path}/view-similar/:id`}
        render={(props) => <GsdFileView type="similar" {...props} />}
      />
    </Switch>
  )
}

export default Gsp
